// import Link from "next/link";

const FeaturesCard = ({
  img,
  title,
  desc,
  subtitle,
  id,
}: // link
{
  id: number;
  img: string;
  subtitle: string;
  title: string;
  desc: string;
  // link?:string;
}) => {
  return (
    <div className="bg-white md:rounded-[22px] flex flex-row lg:flex-col items-center justify-between text-start md:text-center lg:p-4 py-4">
      <div className="text-gray-900 lg:mt-[25px] border-b border-dashed md:border-none border-[#E5EAF6] pb-[13px] grow flex flex-col px-[30px]">
        <h4 className="text-[#001E48] lg:text-sm text-xs">
          {subtitle.toUpperCase()}
        </h4>
        <h3 className="font-bold text-[28px] lg:text-[32px] text-[#004DE3] leading-8 py-3">
          {title}
        </h3>
        <p className="text-sm font-normal lg:pb-0 text-my-light-blue lg:font-light lg:text-base">
          {desc}
        </p>
      </div>
      <button
        className="bg-gradient-to-r from-[#004DE3] to-[#0D00A5] text-white font-[600] text-[18px] tracking-normal py-[16px] px-[58px] my-2 rounded-[14px] hover:scale-[1.02] transition-all duration-300 hover:shadow-lg"
        onClick={(e) => {
          e.preventDefault();
          document.getElementById("search_button")?.click();
        }}
      >
        View Deal
      </button>
    </div>
  );
};

export default FeaturesCard;
